import { useEffect, useState } from "react";
import { ContentsServices, IContent } from "../../../../Services/api/contents/Contents.services";
import { Styled } from "./Styled";


interface IContentItemProps {
    contentId: string;
}

export const ContentItem: React.FC<IContentItemProps> = (props) => {

    const [Content, setContent] = useState<IContent>();

    useEffect(() => {
        const fetch = async () => {
            const result = await ContentsServices.getContentById(props.contentId);
            if (!(result instanceof Error)) {
                setContent(result);
            } else {
                setContent(undefined);
            }
        };
        fetch();
    }, [props.contentId]);

    return (
        <Styled.Content>
            <span>{` - `} </span>    
            <span>{Content?.Name}</span>    
        </Styled.Content>
    )
}